import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

export const COMMERCIAL_ROUTE_NAMES = {
  COMMERCIAL_COSTS: "Commercial costs",
  NEW_COMMERCIAL_COST: "New commercial cost",
  EDIT_COMMERCIAL_COST: "Edit commercial cost",
  COMMERCIAL_CONTRACTS: "Commercial contracts",
  NEW_COMMERCIAL_CONTRACT: "New commercial contract",
  EDIT_COMMERCIAL_CONTRACT: "Edit commercial contract",
};

const CommercialCostsRoutes: Array<CustomRouteConfig> = [
  {
    name: COMMERCIAL_ROUTE_NAMES.COMMERCIAL_COSTS,
    path: "commercial-costs",
    component: () => import(/* webpackChunkName: "commercial-costs" */ "@/views/commercial/CommercialCostsView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CommercialCostsRead] },
  },
  {
    name: COMMERCIAL_ROUTE_NAMES.NEW_COMMERCIAL_COST,
    path: "commercial-costs/new",
    component: () => import(/* webpackChunkName: "commercial-costs" */ "@/views/commercial/CommercialCostNewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CommercialCostsCreate] },
  },
  {
    name: COMMERCIAL_ROUTE_NAMES.EDIT_COMMERCIAL_COST,
    path: "commercial-costs/edit/:id",
    component: () => import(/* webpackChunkName: "commercial-costs" */ "@/views/commercial/CommercialCostEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CommercialCostsUpdate] },
  },
  {
    name: COMMERCIAL_ROUTE_NAMES.COMMERCIAL_CONTRACTS,
    path: "commercial-contracts",
    component: () =>
      import(/* webpackChunkName: "commercial-contracts" */ "@/views/commercial/CommercialContractsView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CommercialCostsRead] },
  },
  {
    name: COMMERCIAL_ROUTE_NAMES.NEW_COMMERCIAL_CONTRACT,
    path: "commercial-contracts/new",
    component: () =>
      import(/* webpackChunkName: "commercial-contracts" */ "@/views/commercial/CommercialContractNewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CommercialCostsCreate] },
  },
  {
    name: COMMERCIAL_ROUTE_NAMES.EDIT_COMMERCIAL_CONTRACT,
    path: "commercial-contracts/edit/:id",
    component: () =>
      import(/* webpackChunkName: "commercial-contracts" */ "@/views/commercial/CommercialContractEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CommercialCostsUpdate] },
  },
];

export { CommercialCostsRoutes };
export default CommercialCostsRoutes;
